// Framer Motion looping-keyframe definitions for the ABA Billing Platform template.
// These are JS animation objects (not CSS), consumed by the <Loop> helper — each entry is a
// set of animated properties + a `times` array. Shared by every page built on this template.

export const ANIM = {
    tlglow: { boxShadow: ['0 0 26px rgba(242,85,28,.35)', '0 0 40px rgba(242,85,28,.6)', '0 0 26px rgba(242,85,28,.35)'], times: [0, 0.5, 1] },
    pl: { opacity: [1, 0.45, 1], times: [0, 0.5, 1] },
    hp1: { opacity: [1, 1, 0, 0, 1, 1], y: [0, 0, -8, -8, 0, 0], times: [0, 0.31, 0.34, 0.96, 0.99, 1] },
    hp2: { opacity: [0, 0, 1, 1, 0, 0], y: [8, 8, 0, 0, -8, -8], times: [0, 0.31, 0.34, 0.64, 0.67, 1] },
    hp3: { opacity: [0, 0, 1, 1, 0], y: [8, 8, 0, 0, -8], times: [0, 0.64, 0.67, 0.97, 1] },
    // Tab-highlight pills reuse the panel timing but WITHOUT the vertical slide (`y`),
    // so the active-tab highlight cross-fades cleanly instead of jumping on the small tab.
    hp1o: { opacity: [1, 1, 0, 0, 1, 1], times: [0, 0.31, 0.34, 0.96, 0.99, 1] },
    hp2o: { opacity: [0, 0, 1, 1, 0, 0], times: [0, 0.31, 0.34, 0.64, 0.67, 1] },
    hp3o: { opacity: [0, 0, 1, 1, 0], times: [0, 0.64, 0.67, 0.97, 1] },
    bx: { backgroundColor: ['#fff', '#fff', '#2E9D5A', '#2E9D5A'], borderColor: ['#C9BEA1', '#C9BEA1', '#2E9D5A', '#2E9D5A'], times: [0, 0.17, 0.2, 1] },
    tk: { opacity: [0, 0, 1, 1], times: [0, 0.18, 0.21, 1] },
    fo: { opacity: [1, 1, 0, 0], scale: [1, 1, 0.8, 0.8], times: [0, 0.11, 0.13, 1] },
    fi: { opacity: [0, 0, 1, 1], scale: [0.8, 0.8, 1, 1], times: [0, 0.12, 0.15, 1] },
    pr: { y: [0, 0, 3, 3, 0, 0], times: [0, 0.25, 0.27, 0.29, 0.31, 1] },
    pr2: { y: [0, 0, 3, 3, 0, 0], times: [0, 0.52, 0.54, 0.56, 0.58, 1] },
    ch: { backgroundColor: ['#fff', '#fff', '#12233D', '#12233D'], borderColor: ['#D8CDB2', '#D8CDB2', '#12233D', '#12233D'], color: ['#12233D', '#12233D', '#F6B32B', '#F6B32B'], times: [0, 0.44, 0.47, 1] },
    pg: { scaleX: [0, 0, 1, 1], times: [0, 0.55, 0.63, 1] },
    r1: { opacity: [0, 0, 1, 1], x: [-10, -10, 0, 0], times: [0, 0.69, 0.72, 1] },
    r2: { opacity: [0, 0, 1, 1], x: [-10, -10, 0, 0], times: [0, 0.72, 0.75, 1] },
    r3: { opacity: [0, 0, 1, 1], x: [-10, -10, 0, 0], times: [0, 0.75, 0.78, 1] },
    bwF: { scaleX: [0, 0, 1, 1], times: [0, 0.06, 0.46, 1] },
    bhF: { scaleY: [0, 0, 1, 1], times: [0, 0.08, 0.48, 1] },
    odo5: { y: ['0%', '0%', '-20%', '-20%', '-40%', '-40%', '-60%', '-60%', '-80%', '-80%'], times: [0, 0.07, 0.09, 0.2, 0.22, 0.33, 0.35, 0.46, 0.48, 1] },
    e1o: { opacity: [1, 1, 0, 0], times: [0, 0.14, 0.18, 1] },
    e1i: { opacity: [0, 0, 1, 1], scale: [0.7, 0.7, 1, 1], times: [0, 0.15, 0.19, 1] },
    e2o: { opacity: [1, 1, 0, 0], times: [0, 0.3, 0.34, 1] },
    e2i: { opacity: [0, 0, 1, 1], scale: [0.7, 0.7, 1, 1], times: [0, 0.31, 0.35, 1] },
    e3o: { opacity: [1, 1, 0, 0], times: [0, 0.46, 0.5, 1] },
    e3i: { opacity: [0, 0, 1, 1], scale: [0.7, 0.7, 1, 1], times: [0, 0.47, 0.51, 1] },
    pc1: { opacity: [0, 0, 1, 1], y: [14, 14, 0, 0], times: [0, 0.16, 0.22, 1] },
    pc2: { opacity: [0, 0, 1, 1], y: [14, 14, 0, 0], times: [0, 0.28, 0.34, 1] },
    pc3: { opacity: [0, 0, 1, 1], y: [14, 14, 0, 0], times: [0, 0.4, 0.46, 1] },
};

/** Global animation speed multiplier — <1 is faster (0.8 ≈ 20% faster than the source). */
export const SPEED = 0.8;
